import { Identity } from './User'

export enum DocumentFileType {
  ZOCKS = 'zocks',
  INTEGRATION = 'integration',
  EMAIL_ATTACHMENT = 'emailAttachment',
}

export enum DocumentState {
  DRAFT = 'draft',
  READY = 'ready',
}

export interface DocumentTypeProcessingStatus {
  startedAt: string | null
  finishedAt: string | null
  typeId: string | null
  label: string | null
}

export interface DocumentSummaryProcessingStatus {
  startedAt: string | null
  finishedAt: string | null
}

interface BaseDocumentFile {
  size: number
  name: string
  contentType: string
  hash?: string
}

export interface ZocksDocumentFile extends BaseDocumentFile {
  type: DocumentFileType.ZOCKS
  fileId: string
  encryptedPassword?: string
}

export interface IntegrationDocumentFile extends BaseDocumentFile {
  type: DocumentFileType.INTEGRATION
  fileId: string
  connector: string
}

export interface EmailAttachmentDocumentFile extends BaseDocumentFile {
  type: DocumentFileType.EMAIL_ATTACHMENT
  fileId: string
  emailId: string
  attachmentId: string
  connector: string
}

export type DocumentFile = ZocksDocumentFile | IntegrationDocumentFile | EmailAttachmentDocumentFile

export interface DocumentRecord {
  id: string
  documentBatchId: string | null
  name: string
  state: DocumentState
  contactId: string | null
  typeProcessing: DocumentTypeProcessingStatus
  summaryProcessing: DocumentSummaryProcessingStatus
  files: DocumentFile[]
  createdBy: Identity
  updatedBy: Identity
  createdAt: string
  updatedAt: string
}

interface BaseDocumentFileCreate {
  size: number
  name: string
  contentType: string
  hash?: string
}

export interface ZocksDocumentFileCreate extends BaseDocumentFileCreate {
  type: DocumentFileType.ZOCKS
  password?: string
}

export interface IntegrationDocumentFileCreate extends BaseDocumentFileCreate {
  type: DocumentFileType.INTEGRATION
  fileId: string
  connector: string
}

export type DocumentFileCreate = ZocksDocumentFileCreate | IntegrationDocumentFileCreate

export interface DocumentCreate {
  name: string
  files: DocumentFileCreate[]
}

export interface DocumentProcessRequest {
  documentIds: string[]
  contactId: string
}

export interface FileUploadTarget {
  documentId: string
  fileId: string
  fileUploadUrl: string
  fileUploadParameters: Record<string, string>
}

export interface DocumentWithUploadTargets {
  document: DocumentRecord
  fileUploadTargets: FileUploadTarget[]
}

export interface DocumentUpdate {
  typeProcessing?: Partial<DocumentTypeProcessingStatus>
  summaryProcessing?: Partial<DocumentSummaryProcessingStatus>
}

export enum DocumentProcessingStatusType {
  SAVED = 'saved',
  READY = 'ready',
  LOADING = 'loading',
  PROCESSING = 'processing',
}
